import { NgModule } from '@angular/core';
import { ComposicaoEquipeListComponent } from '../equipe/composicao-equipe-list.component';
import { ComposicaoEquipeFormComponent } from './composicao-equipe-form.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ComposicaoEquipeListComponent,
    ComposicaoEquipeFormComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    ComposicaoEquipeListComponent
  ]
})
export class EquipeModule { }
